<script></script>

<div>
  <h2>Coming Soon</h2>
  <p>
    The gallery is still being under construction. <br /> Here is a penguin for the
    time being! 🐧
  </p>
  <form action="">
    <input type="email" name="email" placeholder="Enter your email address" />
    <button type="submit">Notify Me</button>
  </form>
  <p>Notify me when the gallery is online.</p>
</div>

<style>
  div {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10em 0;
  }

  h2 {
    margin-bottom: 0.3em;
    font-size: 7rem;
  }

  p {
    font-size: 1.3rem;
  }

  form {
    margin: 2em 0;
  }

  input {
    color: white;
    border: none;
    background-color: #292929;
    padding: 1.1em 1.5em;
    border-radius: 0.3em;
  }

  button {
    all: unset;
    background-color: #fff;
    border: 1px #fff solid;
    color: #000;
    padding: 1em;
    font-weight: bold;
    border-radius: 0.3em;
    cursor: pointer;
    transition: 0.2s ease-in-out;
  }

  button:hover {
    color: #fff;
    background-color: transparent;
  }

  @media screen and (max-width: 55rem) {
    h2 {
      font-size: 5rem;
    }
  }

  @media screen and (max-width: 45rem) {
    h2 {
      font-size: 3rem;
    }

    p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 30em) {
    h2 {
        font-size: 2rem;
    }
  }
</style>
